module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABgAAAAYCAYAAADgdz34AAAACXBIWXMAAAsSAAALEgHS3X78AAAAyUlEQVRIie1VwQ3DIAw8qn7LGnwzAqNkAB7dIGSDSGWAjJIReJY1WMD9QIQqSFCURGqVkywZjH3iLDAjIhyJ26HVTyfgxu2u159JdBHkcN+ayI0bAcAr0XLjNIAuhHqvhI7nqm/AjWu4cU0h3BX8OoJQeAIwJSRDsEVs6kGGsE/CqV/uQaqxV8Jy42RY22+pguY6V6dWohHA0ythIwkACUDGvRKKN/BKtEuJa4VnENFsj9eb0vUe9vsv+fyvYo+h45Vg0WfX0F/DB9I6idZLJKQQAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ic_scatter_blue.png
// module id = 331
// module chunks = 1